/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * OrderDeliveryProgressDtoBase
 * auto generated base class for the model OrderDeliveryProgressDtoModel.
 */
export const OrderDeliveryProgressDtoModelBase = ModelBase
  .named('OrderDeliveryProgressDto')
  .props({
    __typename: types.optional(types.literal("OrderDeliveryProgressDto"), "OrderDeliveryProgressDto"),
    /** Route UUID */
    id: types.identifier,
    orderUuid: types.union(types.undefined, types.string),
    delivered: types.union(types.undefined, types.integer),
    missed: types.union(types.undefined, types.integer),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class OrderDeliveryProgressDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get orderUuid() { return this.__attr(`orderUuid`) }
  get delivered() { return this.__attr(`delivered`) }
  get missed() { return this.__attr(`missed`) }
}
export function selectFromOrderDeliveryProgressDto() {
  return new OrderDeliveryProgressDtoModelSelector()
}

export const orderDeliveryProgressDtoModelPrimitives = selectFromOrderDeliveryProgressDto().orderUuid.delivered.missed
